import { memo } from "react";
import ViewablePackageEntry from "~/features/cart/activeQuote/components/ActiveQuoteReview/ViewablePackageEntry";
import EditablePackageEntry from "~/features/cart/activeQuote/components/productTable/EditablePackageEntry";
import type { QuotePackageEntryViewModel } from "~/features/cart/activeQuote/models/QuoteTableViewModel";

interface PackageEntryListProps {
  packageEntries: QuotePackageEntryViewModel[];
  onRender?: () => void;
}

const PackageEntryList = memo(({ packageEntries, onRender }: PackageEntryListProps) => (
  <div>
    {packageEntries.map((entry, index) =>
      entry.actions.updateOfferPrice !== undefined ? (
        <EditablePackageEntry key={entry.packEntryId} index={index} entryViewModel={entry} onRender={onRender} />
      ) : (
        <div key={entry.packEntryId} className={"pb-2"}>
          <ViewablePackageEntry index={index} entryViewModel={entry} />
        </div>
      ),
    )}
  </div>
));

export default PackageEntryList;
